// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import Login from './components/Login';
import Signup from './components/Signup';
import Dashboard from './components/first/Dashboard';
import Temperature from './components/Temperature/Temperature';
import CO2Level from './components/CO2Level/CO2Level';
import Humidity from './components/Humidity/Humidity';
import ServerStatus from './components/ServerStatus/ServerStatus';
import UPSStatus from './components/UPSStatus/UPSStatus';
import VOCLevel from './components/VOCLevel/VOCLevel';
import MainContent from './components/first/MainContent';
import DataHistory from './components/DataHistory/DataHistory'; // ✅ New import

function App() {
  return (
    <Router>
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />

        {/* Dashboard and nested routes */}
        <Route path="/dashboard" element={<Dashboard />}>
          <Route index element={<MainContent />} /> {/* ✅ Default when /dashboard is accessed */}
          <Route path="temperature" element={<Temperature />} />
          <Route path="co2" element={<CO2Level />} />
          <Route path="humidity" element={<Humidity />} />
          <Route path="server-status" element={<ServerStatus />} />
          <Route path="ups-status" element={<UPSStatus />} />
          <Route path="voc" element={<VOCLevel />} />
          <Route path="data-history" element={<DataHistory />} /> {/* ✅ New history page */}
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
